import React, { ReactElement } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { bottom } from "@popperjs/core";
import { StorageProductRelationProxy } from "@me-team/host/main/graphql/types";
import { RenderWarehousesStockList } from "../../index";
import { StockStatus } from "../types";
import { OverlayInjectedProps } from "react-bootstrap/Overlay";

interface TooltipWarehousesStockListProps {
    children: ReactElement;
    storageProductRelations: StorageProductRelationProxy[];
    productStockStatus: string;
    currentBranchId: number;
}

const TooltipWarehousesStockList: React.FC<TooltipWarehousesStockListProps> = ({
    children,
    storageProductRelations,
    productStockStatus,
    currentBranchId,
}) => {
    const shouldShowTooltip =
        productStockStatus === StockStatus.InStock && storageProductRelations && storageProductRelations.length > 0;

    if (!shouldShowTooltip) {
        return <>{children}</>;
    }

    const renderTooltip = (props: OverlayInjectedProps) => (
        <Tooltip id="tooltip" className="pointer-events-none" {...props}>
            <RenderWarehousesStockList
                storageProductRelations={storageProductRelations}
                currentBranchId={currentBranchId}
            />
        </Tooltip>
    );

    return (
        <OverlayTrigger placement={bottom} overlay={renderTooltip} container={document.body} flip>
            {children}
        </OverlayTrigger>
    );
};

export default TooltipWarehousesStockList;
